/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable object-shorthand */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-param-reassign */
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useHistory, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from "@coreui/react";
import moment from "moment";
import useQuery from "assets/hooks/useQuery";
import SVG, {
  ArrowBackWhiteIcon,
  CartRating,
  // ScooterOutlinedIcon,
} from "assets/svg";
import IMAGES from "assets/img";

import {
  DELIVERY_OPTIONS,
  FOOD_ITEM_TYPES,
  COMMENT_TYPES_OF_RATING_FEATURE,
  COUPON_DETAIL_PAGE_MODES,
  DELIVERY_OPTIONS_CONFIGS,
} from "constants/types";

import SessionStorageUtils from "utils/sessionStorageUtils";

import InfiniteScroll from "react-infinite-scroll-component";

import {
  ButtonBase,
  IconButton,
  LoadingOverlay,
  StoreInfo,
  Post,
  Dock,
} from "views/common/component";
import DetailRatingPost from "views/common/component/DetailRatingPost/DetailRatingPost";
// import Popup from "views/common/component/Popup";
import { FNB_CART_KEY, FNB_CART_TMP_KEY } from "constants/localStorageKeys";
import { uniqByKeepLast } from "utils";
import { icons } from "assets/icons";

import CouponItem from "../StoreDetail/components/CouponItem";

import FirstRater from "./components/Rating/components/FirstRater";
import StoreHeader from "./components/StoreHeader";
import RatingStoreView from "./components/Rating/components/RatingStoreView/RatingStoreView";
import { DealSection } from "./components";

import FoodItem, { FoodItemSkeleton } from "../StoreDetail/components/FoodItem";
import CategoryList from "./components/CategoryList";

import { TYPE } from "./store/constants";
import actions from "./store/actions";
import "./StoreView.scss";

const tabStoreInfo = { code: "store-info-card", name: "Thông tin" };
const tabDeals = { code: "store-view__deal-section", name: "Deal/Voucher" };
const tabRatings = { code: "store-view__rating", name: "Đánh giá" };

const STORE_VIEW_PRODUCT_SECTION = "Nổi bật";
const TAKE_LIST_DEAL = 20;

function StoreView() {
  const query = useQuery();
  const storeId = query.get("storeId");
  const merchantId = query.get("merchantId");

  const history = useHistory();
  const dispatch = useDispatch();
  const {
    ratingData,
    storeInfo,
    storeInfoV2,
    merchantInfo,
    suggestedCouponList,
    shortLinkToShare,
    isLoading,
    bestSellerData,
    userLikedData,
    notAlreadyRatedList,
    listDeal,
  } = useSelector((state) => state[TYPE]);

  const isScrollDown = useRef();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.root);

  // popup states
  const [showSuggestedCouponList, setShowSuggestedCouponList] = useState(false);
  const [showUserLikedList, setShowUserLikedList] = useState(false);
  const [likedListParams, setLikedListParams] = useState({
    skip: 0,
    take: 10,
  });
  const [chosenRatingPost, setChosenRatingPost] = useState();
  const [starActive, setStarActive] = useState(0);
  const [showModalWarning, setShowModalWarning] = useState(false);

  const renderBackBtn = () => {
    if (
      location.state?.prevPathname &&
      location.state?.prevPathname !== "/" // tránh show "Về trang chủ" & "Quay lại" trong khi 2 action là như nhau nếu trang trước là trang chủ
      // location?.state?.prevPathname === "/listfeed" ||
      // location?.state?.prevPathname === "/search"
    ) {
      return (
        <CButton variant="ghost" onClick={handleCloseModalWarning}>
          Quay lại
        </CButton>
      );
    }
  };

  const tabs = useMemo(() => {
    if (
      !isLoading.GET_LIST_DEAL &&
      listDeal?.items?.length > 0 &&
      storeInfoV2?.operationTypes?.includes("Voucher")
    ) {
      return [tabStoreInfo, tabDeals, tabRatings];
    }
    return [tabStoreInfo, tabRatings];
  }, [listDeal, isLoading.GET_LIST_DEAL]);

  // go to see all rating
  const handleSeeAllRating = useCallback(() => {
    const defaultHaveComment = ratingData?.ratings?.length > 0;
    history.push(
      `/rating?storeId=${storeId}&merchantId=${merchantId}&defaultHaveComment=${defaultHaveComment}`
    );
  }, [storeId, merchantId, ratingData?.ratings]);

  // handle show modal

  const handleRatingStar = () => {
    setStarActive(0);
    localStorage.setItem(
      "ratingStar",
      JSON.stringify({
        rating: starActive,
      })
    );

    history.push("/ratingstore", {
      sourceId: notAlreadyRatedList[0],
      RefId: storeId,
      featureId: process.env.REACT_APP_FEATURE_ID,
      rating: 0,
      name: storeInfoV2?.name?.vi,
      merchant: merchantId,
    });
  };

  // useMemo
  const allImagesOfMerchant = useMemo(() => {
    const stores = merchantInfo?.items;
    const res = [];

    if (!stores) {
      return res;
    }

    for (let i = 0; i < stores?.length; i++) {
      if (stores[i]?.data?.images?.iv?.length > 0) {
        if (Array.isArray(stores[i]?.data?.images?.iv)) {
          res.push(...stores[i]?.data?.images?.iv);
        }
      }
    }

    return res;
  }, [merchantInfo?.items]);

  const merchantClass = useMemo(() => {
    if (storeId && merchantInfo) {
      const storeList = merchantInfo.items;

      if (!Array.isArray(storeList)) {
        return null;
      }

      const dataOfThisStore = storeList.find(
        (store) => store.id === merchantId
      );

      return dataOfThisStore?.data?.merchantClass?.iv;
    }
  }, [merchantInfo, storeId]);

  // * call API onMount
  // INITIALIZATION
  useLayoutEffect(() => {
    if (history.action !== "POP") {
      window.scrollTo({ top: 0 });
    }

    // set default scroll direction to DOWN
    isScrollDown.current = true;
  }, []);

  // * handle scroll to show or hide store header
  useEffect(() => {
    const storeHeader = document.getElementById("store-header");
    const storeSlider = document.getElementById("store-detail-info-slider");

    let lastScrollY = 0;

    const handleScrollPage = () => {
      if (!storeHeader || !storeSlider) {
        return;
      }

      // get the scroll direction info
      isScrollDown.current = lastScrollY < window.scrollY;

      lastScrollY = window.scrollY; // store current scrollY value

      // stuff to handle store header display
      // if (isSearching) {
      //   storeHeader.style.display = "block";
      //   storeHeader.style.opacity = 1;
      //   return;
      // }

      storeHeader.style.opacity =
        window.scrollY /
        (storeSlider.offsetHeight -
          storeHeader.offsetHeight -
          40 -
          15) /* 40px = khoảng trồi lên của store info card | 15px = khoảng trồi lên của merchantClass */;

      // set display sau khi update opacity để tránh hiện tượng chớp từ mờ -> rõ khi scroll xuống
      if (window.scrollY < 10) {
        storeHeader.style.display = "none";
      } else {
        storeHeader.style.display = "block";
      }
    };

    window.addEventListener("scroll", handleScrollPage);

    return () => {
      window.removeEventListener("scroll", handleScrollPage);
    };
  }, [
    isLoading.GET_MERCHANT_INFO,
    isLoading.GET_STORE_INFO,
    isLoading.GET_SUGGESTED_COUPON_LIST,
    // 3 deps ở trên là vì phải đợi StoreInfo load xong mới có slider để getElementById
  ]);

  // * call API get store info, store info v2, merchant info, best seller, list deal
  useEffect(() => {
    // không check có storeId mới call: vì initialState isLoading của các action này là true
    // set initial isLoading: true để check sau khi call xong có data (storeInfo, storeInfoV2) hay không
    // nếu không: show popup báo cửa hàng không khả dụng
    dispatch(actions.GET_STORE_INFO.request(storeId));
    dispatch(actions.GET_STORE_INFO_V2.request(storeId));

    if (merchantId) {
      dispatch(actions.GET_MERCHANT_INFO.request(merchantId));
    }

    if (merchantId) {
      dispatch(actions.GET_BEST_SELLER_LIST.request(merchantId));
    }

    if (storeId && merchantId) {
      const pinnedLocation = JSON.parse(localStorage.getItem("myLocation"));

      if (pinnedLocation.lat) {
        dispatch(
          actions.GET_LIST_DEAL.request({
            storeId,
            merchantId,
            Latitude: pinnedLocation.lat,
            Longitude: pinnedLocation.long,
            Skip: 0,
            Take: TAKE_LIST_DEAL,
          })
        );
      }
    }
  }, []);

  // * call API get list suggest rating
  useEffect(() => {
    if (storeId) {
      dispatch(actions.GET_NOT_ALREADY_RATED_LIST.request(storeId));

      // const FnBCartFromLS = JSON.parse(localStorage.getItem(FNB_CART_KEY));

      // if(!!FnBCartFromLS?.storeIdTmp){
      //   localStorage.setItem(
      //     FNB_CART_KEY,
      //     JSON.stringify({
      //       ...FnBCartFromLS,
      //       storeIdTmp: storeId,
      //     })
      //   );
      // }
    }
  }, [storeId]);

  useEffect(() => {
    if (userInfo) {
      dispatch(
        actions.GET_RATING_LIST.request({
          refId: storeId,
          featureId: process.env.REACT_APP_FEATURE_ID,
          haveComment: true, // rule
          sortingType: 0,
          take: 2,
          skip: 0,
        })
      );
    }
  }, [userInfo]);

  // * GET_SUGGESTED_COUPON_LIST
  useEffect(() => {
    let viewAsGuest = true;

    if (userInfo) {
      viewAsGuest = false;
    }

    dispatch(
      actions.GET_SUGGESTED_COUPON_LIST.request({
        storeId,
        merchantId,
        viewAsGuest,
      })
    );
  }, [userInfo, storeId, merchantId]);

  // * tracking data of chosenRatingPost changes
  // * (changes was made on DetailRatingPost popup)
  useEffect(() => {
    if (ratingData?.ratings && chosenRatingPost?.id) {
      setChosenRatingPost(
        ratingData.ratings.find((post) => post.id === chosenRatingPost?.id)
      );
    }
  }, [ratingData?.ratings]);

  // * check if data is draft on CMS, then show warning modal
  useEffect(() => {
    if (isLoading.GET_STORE_INFO || isLoading.GET_STORE_INFO_V2) return;

    if (!storeInfo || !storeInfoV2) {
      setShowModalWarning(true);
    }
  }, [
    isLoading.GET_STORE_INFO,
    isLoading.GET_STORE_INFO_V2,
    storeInfo,
    storeInfoV2,
  ]);

  // *** keep scroll position (temp implementation)
  useEffect(() => {
    if (history.action !== "POP") return;
    if (!listDeal?.items?.length > 0) return;
    if (
      isLoading.GET_MERCHANT_INFO ||
      isLoading.GET_STORE_INFO ||
      isLoading.GET_STORE_INFO_V2 ||
      isLoading.GET_BEST_SELLER_LIST ||
      isLoading.GET_SUGGESTED_COUPON_LIST ||
      isLoading.GET_RATING_LIST ||
      isLoading.GET_NOT_ALREADY_RATED_LIST ||
      isLoading.GET_LIST_DEAL
      // isLoading.SAVE_SUGGESTED_COUPON ||
      // isLoading.GET_SHORT_LINK_TO_SHARE ||
      // isLoading.GET_USER_LIKED_LIST_OF_RATING_POST ||
      // isLoading.GET_USER_LIKED_LIST_OF_COMMENT ||
      // isLoading.POST_LIKE_CMT ||
      // isLoading.POST_UNLIKE_CMT ||
      // isLoading.POST_LIKE_SUB_CMT ||
      // isLoading.POST_UNLIKE_SUB_CMT ||
      // isLoading.POST_REPLY_CMT
    ) {
      return;
    }

    const cachedData = SessionStorageUtils.restoreLoadedData({
      pathname: history.location.pathname,
      search: history.location.search,
    });

    if (cachedData?.windowScrollY) {
      window.scrollTo(0, cachedData.windowScrollY);
    }
  }, [
    isLoading.GET_MERCHANT_INFO,
    isLoading.GET_STORE_INFO,
    isLoading.GET_STORE_INFO_V2,
    isLoading.GET_BEST_SELLER_LIST,
    isLoading.GET_SUGGESTED_COUPON_LIST,
    isLoading.GET_RATING_LIST,
    isLoading.GET_NOT_ALREADY_RATED_LIST,
    isLoading.GET_LIST_DEAL,
    listDeal,
  ]);

  // * NAVIGATE
  const goBack = () => {
    if (
      // history.location.state?.prevPathname === "/" ||
      // history.location.state?.prevPathname === "/listfeed" ||
      // history.location.state?.prevPathname === "/search"
      history.location.state?.prevPathname
    ) {
      history.goBack();
      return;
    }

    console.warn("abnormal case: prev page is missing");
    history.push("/");
  };

  const navigateToSmartOrderMenu = useCallback(
    (deliveryOptionSelected) => {
      const FnBCartFromLS = JSON.parse(localStorage.getItem(FNB_CART_KEY));
      const FnBCartTmpFromLS = JSON.parse(
        localStorage.getItem(FNB_CART_TMP_KEY)
      );
      const foundDeliveryConfig = storeInfoV2.deliveryConfigs?.find(
        (option) =>
          String(option.type).toLowerCase() === DELIVERY_OPTIONS.HOME ||
          String(option.type).toLowerCase() === DELIVERY_OPTIONS.SHOP ||
          String(option.type).toLowerCase() === DELIVERY_OPTIONS.TABLE
      );

      const listDeliveryOptions = createListMethodDelivery(
        storeInfoV2.deliveryOptions,
        !!storeInfoV2.deliveryConfigs &&
          storeInfoV2.deliveryConfigs.length > 0 &&
          foundDeliveryConfig
          ? storeInfoV2.deliveryConfigs
          : DELIVERY_OPTIONS_CONFIGS
      );

      if (
        deliveryOptionSelected === undefined ||
        Object.keys(deliveryOptionSelected).length === 0
      ) {
        if (
          !!FnBCartTmpFromLS?.listDeliveryOptions &&
          !!FnBCartTmpFromLS?.storeId &&
          !!storeId &&
          FnBCartTmpFromLS?.storeId === storeId
        ) {
          FnBCartTmpFromLS?.listDeliveryOptions?.forEach((option) => {
            if (option.isCheck) {
              deliveryOptionSelected = option.type.toLowerCase();
            }
          });
        } else {
          if (
            !!FnBCartFromLS?.storeId &&
            !!storeId &&
            !!FnBCartFromLS?.items &&
            FnBCartFromLS?.items.length > 0 &&
            FnBCartFromLS?.storeId === storeId
          ) {
            FnBCartFromLS?.listDeliveryOptions?.forEach((option) => {
              if (option.isCheck) {
                deliveryOptionSelected = option.type.toLowerCase();
              }
            });
          } else {
            if (listDeliveryOptions?.length > 0) {
              const foundShopOption = listDeliveryOptions?.find(
                (option) =>
                  String(option?.type).toLowerCase() ===
                    DELIVERY_OPTIONS.SHOP ||
                  String(option?.type).toLowerCase() === DELIVERY_OPTIONS.TABLE
              );

              if (foundShopOption) {
                deliveryOptionSelected = "shop";
              } else {
                deliveryOptionSelected = "home";
              }
            } else {
              deliveryOptionSelected = "shop";
            }
          }
        }
      }

      // const foundDeliveryConfig = storeInfoV2.deliveryConfigs?.find(
      //   (option) =>
      //     String(option.type).toLowerCase() === DELIVERY_OPTIONS.HOME &&
      //     (String(option.type).toLowerCase() === DELIVERY_OPTIONS.SHOP ||
      //       String(option.type).toLowerCase() === DELIVERY_OPTIONS.TABLE)
      // );

      // const listDeliveryOptions = createListMethodDelivery(
      //   storeInfoV2.deliveryOptions,
      //   !!storeInfoV2.deliveryConfigs &&
      //     storeInfoV2.deliveryConfigs.length > 0 &&
      //     foundDeliveryConfig
      //     ? storeInfoV2.deliveryConfigs
      //     : DELIVERY_OPTIONS_CONFIGS
      // );

      let listDeliveryOptionsTmp = [];
      if (listDeliveryOptions.length > 0) {
        listDeliveryOptionsTmp = listDeliveryOptions.map(
          (itemDeliveryOptions) => {
            itemDeliveryOptions.isCheck = false;
            if (
              itemDeliveryOptions.type.toLowerCase() ===
              deliveryOptionSelected.toLowerCase()
            ) {
              itemDeliveryOptions.isCheck = true;
            }
            return itemDeliveryOptions;
          }
        );
      }

      localStorage.setItem(
        FNB_CART_TMP_KEY,
        JSON.stringify({
          ...FnBCartTmpFromLS,
          listDeliveryOptions: [...listDeliveryOptionsTmp],
          storeId: storeId,
          deliveryOptionSelected: deliveryOptionSelected.toLowerCase(),
        })
      );

      // localStorage.setItem(
      //   FNB_CART_KEY,
      //   JSON.stringify({
      //     ...FnBCartFromLS,
      //     listDeliveryOptions: [...listDeliveryOptionsTmp],
      //   })
      // );

      // navigate to smart order menu
      history.push(`/storedetail?storeId=${storeId}&merchantId=${merchantId}`, {
        couponToUse: history.location.state?.couponToUse,
        deliveryOptionSelected: deliveryOptionSelected.toLowerCase(),
      });
    },
    [storeId, merchantId, storeInfoV2]
  );

  // * SHARE
  const handleTriggerWebShareAPI = async (_shortLinkToShare) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Chia sẻ liên kết của cửa hàng",
          text: `Bạn được giới thiệu trải nghiệm ${
            storeInfo?.data?.name?.vi ||
            storeInfo?.data?.name?.en ||
            storeInfo?.data?.name?.iv
          } trên ứng dụng Utop. Nhấn link bên dưới để đăng ký và nhận ưu đãi.\n${_shortLinkToShare}`,
        });
      } catch (err) {
        console.error(err);
      }
    } else {
      console.error("navigator.share is not available on this browser");
    }
  };

  const handleGetShortLinkToShare = () => {
    if (!shortLinkToShare) {
      dispatch(
        actions.GET_SHORT_LINK_TO_SHARE.request({
          url: window.location.href,
          callbackFunction: handleTriggerWebShareAPI,
        })
      );

      return;
    }

    handleTriggerWebShareAPI(shortLinkToShare);
  };

  // * SAVE COUPON
  const handleSaveCoupon = useCallback(
    (cpCode) => () => {
      if (!userInfo) {
        toast.warn("Vui lòng đăng nhập để nhận ngay ưu đãi.", {
          toastId: `${TYPE}_SAVE_SUGGESTED_COUPON__REQUIRE_LOGIN`,
          onClick: () => {
            history.push("/login");
          },
        });

        return;
      }

      if (cpCode) {
        dispatch(actions.SAVE_SUGGESTED_COUPON.request(cpCode));
      }
    },
    [userInfo]
  );

  // * GO TO DETAIL COUPON PAGE
  const handleGotoDetailCoupon = useCallback(
    ({ idCoupon, transactionCode }) =>
      () => {
        history.push(`/coupondetail?id=${idCoupon}`, {
          mode: COUPON_DETAIL_PAGE_MODES.ALLOCATE,
          callbackUrl: `${window.location.pathname}${window.location.search}`,
          isAllocated: !!transactionCode,
        });
      },
    []
  );

  // * POPUP TOGGLE FUNCTIONS
  const handleOpenPopupSuggestedCouponList = () => {
    setShowSuggestedCouponList(true);
  };
  const handleClosePopupSuggestedCouponList = () => {
    setShowSuggestedCouponList(false);
  };
  const handleCloseUserLikedList = () => {
    setShowUserLikedList(false);
  };

  // * MODAL
  const handleCloseModalWarning = () => {
    if (history.location.state?.prevPathname) {
      history.goBack();
      return;
    }

    history.push("/"); // cho trường hợp mở trực tiếp từ link share mà gặp store này ko còn khả dụng
  };

  const handleOpenUserLikedList =
    ({ id, type, skip = 0 }) =>
    () => {
      setLikedListParams({ id, type, skip });
      handleFetchLikedList({
        id,
        type,
        skip: 0,
        needToClearExistedList: true,
      })();
      setShowUserLikedList(true);
    };

  const handleFetchLikedList = useCallback(
    ({ id, type, skip, take = 10, needToClearExistedList = false }) =>
      () => {
        if (
          !id ||
          ![
            COMMENT_TYPES_OF_RATING_FEATURE.RATING_POST,
            COMMENT_TYPES_OF_RATING_FEATURE.COMMENT,
          ].includes(type)
        ) {
          console.warn("invalid params");
          return;
        }

        const params = {
          id,
          skip,
          take,
          needToClearExistedList,
        };

        setLikedListParams({ id, type, skip });

        if (type === COMMENT_TYPES_OF_RATING_FEATURE.RATING_POST) {
          dispatch(actions.GET_USER_LIKED_LIST_OF_RATING_POST.request(params));
        }

        if (type === COMMENT_TYPES_OF_RATING_FEATURE.COMMENT) {
          dispatch(actions.GET_USER_LIKED_LIST_OF_COMMENT.request(params));
        }
      },
    []
  );

  // *** DEAL/VOUCHER FUNCTIONS
  const handleDirectToVoucherViewPage = useCallback(
    ({ idVoucher }) =>
      () => {
        history.push(`/voucherview?id=${idVoucher}`, {
          couponToUse: history.location.state?.couponToUse,
        });
      },
    []
  );

  const handleDirectToListDealPage = useCallback(() => {
    history.push(`/listdeal?ids=${storeId}_${merchantId}`, {
      listDeal,
      couponToUse: history.location.state?.couponToUse,
    });
  }, [listDeal]);

  // *** RATING POST FUNCTIONS
  const handleLikeCmt = useCallback(
    (id) => () => {
      dispatch(actions.POST_LIKE_CMT.request(id));
    },
    []
  );

  const handleUnlikeCmt = useCallback(
    (id) => () => {
      dispatch(actions.POST_UNLIKE_CMT.request(id));
    },
    []
  );

  const handleUnLikeSubCmt = (replyId, postId) => () => {
    dispatch(actions.POST_UNLIKE_SUB_CMT.request({ replyId, postId }));
  };

  const handleLikeSubCmt = (replyId, postId) => () => {
    dispatch(actions.POST_LIKE_SUB_CMT.request({ replyId, postId }));
  };

  // * Viết phản hồi
  const handleSubmitReply = useCallback(({ idRatingPost, content }) => {
    const body = {
      featureId: process.env.REACT_APP_FEATURE_ID,
      sourceId: idRatingPost,
      content,
    };

    dispatch(actions.POST_REPLY_CMT.request(body));
  }, []);

  // * SHOW DETAIL POST
  const handleShowDetailRatingPost = useCallback(
    (ratingPost) => () => {
      if (ratingPost) {
        setChosenRatingPost(ratingPost);
      }
    },
    [ratingData]
  );

  const handleCloseDetailRatingPost = useCallback(() => {
    setChosenRatingPost(null);
  }, []);

  const createListMethodDelivery = (arr = [], deliveryConfigs) => {
    let listMethodDelivery = [];
    let arrTmp = [];
    if (arr.length === 0) {
      let deliveryConfigsTmp = deliveryConfigs.filter(
        (config) =>
          config.type.toLowerCase() === DELIVERY_OPTIONS.SHOP.toLowerCase()
      );
      arrTmp.push(deliveryConfigsTmp[0].type);
    } else {
      arrTmp = [...arr];
    }
    arrTmp.forEach((ite) => {
      let name = "";
      switch (ite.toLowerCase()) {
        case DELIVERY_OPTIONS.PICKUPTIME:
        case DELIVERY_OPTIONS.TAKEAWAY:
        case DELIVERY_OPTIONS.TABLE:
          name = DELIVERY_OPTIONS.SHOP;
          ite = DELIVERY_OPTIONS.SHOP;
          break;

        case DELIVERY_OPTIONS.SHOP:
          name = DELIVERY_OPTIONS.SHOP;
          break;
        case DELIVERY_OPTIONS.HOME:
          name = DELIVERY_OPTIONS.HOME;
          break;
        default:
          name = "";
          break;
      }

      let conf = deliveryConfigs.filter(
        (config) => config.type.toLowerCase() === ite.toLowerCase()
      );
      listMethodDelivery.push({
        type: ite.toLowerCase(),
        label: conf.length > 0 ? conf[0]?.label : name,
        icon: conf.length > 0 ? conf[0]?.icon : "",
      });
    });
    let cookListMethodDelivery = uniqByKeepLast(listMethodDelivery, (it) =>
      it.type.toLowerCase()
    );
    return cookListMethodDelivery;
  };

  // *** RENDER UI
  const renderHighlightSection = useCallback(() => {
    if (isLoading.GET_STORE_INFO_V2 || isLoading.GET_BEST_SELLER_LIST) {
      return (
        <div className="product-section">
          <div className="best-seller__container product-section-child">
            <div className="label">
              <Skeleton width="10ch" />
            </div>

            <div className="products__container">
              <FoodItemSkeleton />
              <FoodItemSkeleton />
            </div>
          </div>

          <div className="action-buttons__container action-buttons__container--skeleton product-section-child">
            <Skeleton />
            <Skeleton />
          </div>
        </div>
      );
    }

    const pattern = /FnB|Market/i;

    if (!storeInfoV2?.operationTypes?.some((opType) => pattern.test(opType)))
      return <></>;

    const foundDeliveryConfig = storeInfoV2.deliveryConfigs?.find(
      (option) =>
        String(option.type).toLowerCase() === DELIVERY_OPTIONS.HOME ||
        String(option.type).toLowerCase() === DELIVERY_OPTIONS.SHOP ||
        String(option.type).toLowerCase() === DELIVERY_OPTIONS.TABLE
    );

    const listDeliveryOptions = createListMethodDelivery(
      storeInfoV2.deliveryOptions,
      !!storeInfoV2.deliveryConfigs &&
        storeInfoV2.deliveryConfigs.length > 0 &&
        foundDeliveryConfig
        ? storeInfoV2.deliveryConfigs
        : DELIVERY_OPTIONS_CONFIGS
    );

    const foundHomeOptionConfig = listDeliveryOptions?.find(
      (option) => String(option.type).toLowerCase() === DELIVERY_OPTIONS.HOME
    );

    const foundShopOptionConfig = listDeliveryOptions?.find(
      (option) => String(option.type).toLowerCase() === DELIVERY_OPTIONS.SHOP
    );

    const foundShopOption = storeInfoV2.deliveryOptions?.find(
      (option) =>
        String(option).toLowerCase() === DELIVERY_OPTIONS.SHOP ||
        String(option).toLowerCase() === DELIVERY_OPTIONS.TABLE
    );
    let deliveryHomeButton = null;

    if (!foundHomeOptionConfig && !foundShopOption) {
      deliveryHomeButton = null;
    } else {
      deliveryHomeButton = (
        <div className="action-buttons__container product-section-child">
          {foundShopOptionConfig &&
            (foundShopOption ||
              (!foundShopOption && !foundHomeOptionConfig)) && (
              <ButtonBase
                className="action-button"
                onClick={() => {
                  navigateToSmartOrderMenu(foundShopOptionConfig.type);
                }}
              >
                <i>
                  <img
                    src={foundShopOptionConfig.icon || icons.iconDefaultShop}
                    style={{ height: 18 }}
                    onError={(event) => {
                      event.target.src = icons.iconDefaultShop;
                    }}
                  />
                </i>
                <span>
                  {foundShopOptionConfig?.label?.vi ||
                    foundShopOptionConfig?.label?.en ||
                    foundShopOptionConfig?.label?.iv ||
                    foundShopOptionConfig?.label?.toUpperCase() ||
                    "ĐẶT MÓN"}
                </span>
              </ButtonBase>
            )}

          {foundHomeOptionConfig && (
            <ButtonBase
              className="action-button"
              onClick={() => {
                navigateToSmartOrderMenu(foundHomeOptionConfig.type);
              }}
            >
              <i>
                <img
                  src={foundHomeOptionConfig.icon || icons.iconDefaultHome}
                  style={{ height: 18 }}
                  onError={(event) => {
                    event.target.src = icons.iconDefaultHome;
                  }}
                />
              </i>
              <span>
                {foundHomeOptionConfig?.label?.vi ||
                  foundHomeOptionConfig?.label?.en ||
                  foundHomeOptionConfig?.label?.iv ||
                  foundHomeOptionConfig?.label?.toUpperCase() ||
                  "GIAO VỀ"}
              </span>
            </ButtonBase>
          )}
        </div>
      );
    }

    // create UI action button(s)
    // if (foundHomeOptionConfig) {
    //   deliveryHomeButton = (
    //     <div className="action-buttons__container product-section-child">
    //       <ButtonBase
    //         className="action-button"
    //         onClick={navigateToSmartOrderMenu}
    //       >
    //         <i>
    //           <img src={foundHomeOptionConfig.icon} style={{ height: 18 }} />
    //         </i>
    //         <span>
    //           {foundHomeOptionConfig?.label?.vi ||
    //             foundHomeOptionConfig?.label?.en ||
    //             foundHomeOptionConfig?.label?.iv ||
    //             foundHomeOptionConfig?.label ||
    //             "GIAO VỀ"}
    //         </span>
    //       </ButtonBase>
    //     </div>
    //   );
    // } else {
    //   deliveryHomeButton = (
    //     <div className="action-buttons__container product-section-child">
    //       <ButtonBase
    //         className="action-button"
    //         onClick={navigateToSmartOrderMenu}
    //       >
    //         <i>
    //           <ScooterOutlinedIcon />
    //         </i>
    //         <span>GIAO VỀ</span>
    //       </ButtonBase>
    //     </div>
    //   );
    // }

    let bestSellerList = [];

    // create UI best seller section
    if (bestSellerData?.items?.length) {
      // rule: take 2 latest product theo lastUpdated
      bestSellerList = [...bestSellerData.items]
        .sort(
          (first, second) =>
            new Date(second.lastModified) - new Date(first.lastModified)
        )
        .slice(0, 2);
    }

    if (!bestSellerList.length > 0 && !deliveryHomeButton) {
      return <></>;
    }

    const calDiscount = (listPrice, price) => {
      let percentDiscount = 0;
      if (!!listPrice && !!price) {
        percentDiscount = 100 - Math.round((price / listPrice) * 100);
        if (percentDiscount === 100) {
          percentDiscount -= 1;
        }
      }
      return percentDiscount;
    };

    return (
      <div className="product-section" style={{ margin: 0, marginTop: 10 }}>
        {bestSellerList.length > 0 && (
          <div className="best-seller__container product-section-child">
            <div className="label">{STORE_VIEW_PRODUCT_SECTION}</div>

            <div className="products__container">
              {bestSellerList.map((product) => (
                <FoodItem
                  key={product.id}
                  id={product.id}
                  code={product?.data?.code?.iv}
                  type={FOOD_ITEM_TYPES.DETAILS} // must have
                  title={product?.data?.name?.iv}
                  imgSrc={product?.data?.imageUrl?.iv}
                  description={product?.data?.description?.iv}
                  shortDescription={product?.data?.shortDescription?.iv}
                  originalPrice={product?.data?.listPrice?.iv}
                  currentPrice={product?.data?.price?.iv}
                  navigateToSmartOrderMenu={navigateToSmartOrderMenu}
                  saleTagUrl={product?.saleTagUrl}
                  percentDiscount={calDiscount(
                    product?.price?.list,
                    product?.price?.default
                  )}
                />
              ))}
            </div>
          </div>
        )}

        {deliveryHomeButton}
      </div>
    );
  }, [
    isLoading.GET_STORE_INFO_V2,
    isLoading.GET_BEST_SELLER_LIST,
    bestSellerData,
    storeInfoV2,
  ]);

  // * Render check UI to suggest user Rate or not rate
  const handleCheckRatedOfUser = () => {
    if (userInfo === null) {
      return <FirstRater href="/login" />;
    }

    const dataAlreadyRate = JSON.parse(localStorage.getItem("storeViewRated"));
    const dateToday = moment(Date.now()).format("DD");
    let dateFormatted;

    if (dataAlreadyRate) {
      // check if this user?
      if (userInfo?.userId === dataAlreadyRate?.userId) {
        if (storeId === dataAlreadyRate.storeId) {
          dateFormatted = moment(dataAlreadyRate?.ratedAtDate).format("DD");
        }
      }

      // check if this storeId
    }

    const header = (
      <RatingStoreView
        ratingData={ratingData}
        handleSeeAllRating={handleSeeAllRating}
      />
    );
    let body;

    // * Tạm chưa có lời bình, mua ngay đơn hàng và đánh giá cửa hàng. Icon Giỏ hàng
    if (
      (ratingData?.ratings?.length === 0 &&
        notAlreadyRatedList?.length === 0) ||
      (ratingData?.ratings?.length === 0 &&
        notAlreadyRatedList?.length > 0 &&
        dateFormatted === dateToday) // đã có rating trong ngày
    ) {
      // console.log(
      //   "Tạm chưa có lời bình, mua ngay đơn hàng và đánh giá cửa hàng. Icon Giỏ hàng"
      // );
      body = (
        <FirstRater
          title="Tạm chưa có lời bình, mua ngay đơn hàng và đánh giá cửa hàng."
          iconFirstRater={<CartRating />}
          hasButton={false}
          titleRate=""
          addMoreClassName="add-margin-top"
        />
      );
    } else if (
      ratingData?.ratings?.length === 0 &&
      notAlreadyRatedList?.length > 0 &&
      dateFormatted !== dateToday // chưa rating trong ngày
    ) {
      // Hãy là người đầu tiên chia sẻ cảm nhận của bạn về cửa hàng. Icon comment
      // console.log(
      //   "Hãy là người đầu tiên chia sẻ cảm nhận của bạn về cửa hàng. Icon comment"
      // );
      body = (
        <FirstRater
          title="Hãy là người đầu tiên chia sẻ cảm nhận của bạn về cửa hàng."
          buttonContent="Đánh giá"
          href=""
          titleRate=""
          onClick={handleRatingStar}
          addMoreClassName="add-margin-top"
        />
      );
    } else if (
      ratingData?.ratings?.length > 0 &&
      notAlreadyRatedList?.length > 0 &&
      dateFormatted !== dateToday // chưa rating trong ngày
    ) {
      // * Chia sẻ cảm nhận bạn để người dùng khác có trải nghiệm tốt hơn. Icon Comment
      // console.log(
      //   "Chia sẻ cảm nhận bạn để người dùng khác có trải nghiệm tốt hơn. Icon Comment"
      // );
      body = (
        <FirstRater
          title="Chia sẻ cảm nhận của bạn giúp người dùng khác tìm được trải nghiệm tốt hơn."
          buttonContent="Đánh giá"
          titleRate=""
          href=""
          onClick={handleRatingStar}
          addMoreClassName="add-margin-top"
        />
      );
    }
    return (
      <>
        {header}

        {body}

        {ratingData.ratings?.length > 0 &&
          ratingData.ratings.map((ratingPost) => (
            <div
              key={ratingPost.id}
              style={{ marginLeft: "-8px", marginRight: "-8px" }}
            >
              <div className="rating-content__line-break"> </div>
              <Post
                rating={ratingPost}
                handleUnlikeCmt={handleUnlikeCmt}
                handleLikeCmt={handleLikeCmt}
                handleOpenUserLikedList={handleOpenUserLikedList}
                handleLikeSubCmt={handleLikeSubCmt}
                handleUnLikeSubCmt={handleUnLikeSubCmt}
                handleSeeAllRating={handleSeeAllRating}
                handleClickToRepliesButton={handleShowDetailRatingPost(
                  ratingPost
                )}
              />
            </div>
          ))}

        {ratingData?.ratings?.length >= 2 && <SeeMore />}
      </>
    );
  };

  // render UI see more
  const SeeMore = useCallback(() => {
    return (
      <>
        <div
          style={{
            borderTop: "1px solid rgb(222, 222, 222)",
            marginLeft: -12,
            marginRight: -12,
            marginTop: 16,
          }}
        />
        <div className="rating-content__see-more" onClick={handleSeeAllRating}>
          <p>Xem thêm</p>
          <img src={SVG.ArrowRightYellow} alt="arrow" />
        </div>
      </>
    );
  }, [handleSeeAllRating]);

  const renderLoaderOfUserLiked = useCallback(() => {
    if (
      !(
        (isLoading.GET_USER_LIKED_LIST_OF_RATING_POST ||
          isLoading.GET_USER_LIKED_LIST_OF_COMMENT) &&
        likedListParams.skip === 0
      )
    ) {
      return (
        <div className="people-liked-list">
          <div className="row-info">
            <Skeleton className="row-info__avatar" circle />
            <span className="row-info__name">
              <Skeleton width="23ch" />
            </span>
          </div>

          <div className="row-info">
            <Skeleton className="row-info__avatar" circle />
            <span className="row-info__name">
              <Skeleton width="23ch" />
            </span>
          </div>
        </div>
      );
    }
  }, [
    isLoading.GET_USER_LIKED_LIST_OF_RATING_POST,
    isLoading.GET_USER_LIKED_LIST_OF_COMMENT,
    likedListParams.skip === 0,
  ]);

  return (
    <div className="store-view-page">
      <div className="buttons-bar--fixed-top">
        <IconButton onClick={goBack} className="button-back--top-left">
          <i>
            <ArrowBackWhiteIcon />
          </i>
        </IconButton>
      </div>

      <div
        id="store-header"
        className="store-header__wrapper"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 3,
          opacity: 0,
          display: "none",
        }}
      >
        {!isLoading.GET_STORE_INFO && (
          <>
            <StoreHeader
              idSearchInput="store-detail__store-header__search-input"
              storeName={storeInfo?.data?.name?.vi}
              isSearching={false} // ! hard code, vì store view hiện tại ko có search
              handleChangeSearchStatus={() => {}}
              goBack={goBack}
              onCommitInputSearch={() => {}}
            />
            <CategoryList categories={tabs} />
          </>
        )}
      </div>

      <div>
        <StoreInfo
          idPivot="store-info-card"
          id={storeInfo?.id}
          isLoading={
            isLoading.GET_MERCHANT_INFO ||
            isLoading.GET_STORE_INFO ||
            isLoading.GET_SUGGESTED_COUPON_LIST
          }
          images={storeInfo?.data?.images?.iv}
          merchantImages={allImagesOfMerchant}
          merchantClass={merchantClass}
          name={storeInfo?.data?.name?.vi}
          avgRate={storeInfo?.data?.avgRate?.iv}
          avgPrice={storeInfo?.data?.avgPrice?.iv}
          openingTimes={storeInfo?.data?.openingTimes?.iv}
          address={storeInfo?.data?.address?.iv}
          phoneNumber={storeInfo?.data?.phone?.iv}
          deliveryOptions={storeInfo?.data?.deliveryOptions?.iv}
          location={storeInfo?.data?.location?.iv}
          tags={storeInfo?.data?.tags?.iv}
          // selector
          suggestedCouponList={suggestedCouponList}
          handleShareStore={handleGetShortLinkToShare}
          handleOpenPopupSuggestedCouponList={
            handleOpenPopupSuggestedCouponList
          }
          handleSaveCoupon={handleSaveCoupon}
          handleGotoDetailCoupon={handleGotoDetailCoupon}
        />
      </div>

      <LoadingOverlay isLoading={isLoading.GET_SHORT_LINK_TO_SHARE} />

      <div className="content">
        {renderHighlightSection()}

        {storeInfoV2 && storeInfoV2.operationTypes?.includes("Voucher") && (
          <DealSection
            idPivot="store-view__deal-section"
            isLoading={isLoading.GET_LIST_DEAL}
            listDeal={listDeal?.items}
            handleDirectToListDealPage={handleDirectToListDealPage}
            handleDirectToVoucherViewPage={handleDirectToVoucherViewPage}
          />
        )}

        <div id="store-view__rating" className="store-view__rating-layout">
          {isLoading.GET_RATING_LIST ? (
            <Skeleton />
          ) : (
            <div className="rating-content">{handleCheckRatedOfUser()}</div>
          )}
        </div>
      </div>

      {suggestedCouponList?.length > 0 && (
        <Dock
          show={showSuggestedCouponList}
          showBtnClose
          handleClose={handleClosePopupSuggestedCouponList}
        >
          <div
            className="color-ucla_gold _fs-15px _fw-600 text-center text-1-line"
            style={{
              padding: "16px 40px 8px",
              lineHeight: "18px",
            }}
          >
            Ưu đãi hiện có
          </div>
          <div className="suggested-coupons">
            <div className="suggested-coupons__list">
              {suggestedCouponList?.map((coupon) => (
                <CouponItem
                  key={coupon?.couponId}
                  couponId={coupon?.couponId}
                  couponCode={coupon?.couponCode}
                  code={coupon?.code}
                  endDateTime={coupon?.endDateTime}
                  name={coupon?.name}
                  isAllocated={coupon?.isAllocated}
                  handleSave={handleSaveCoupon}
                  handleOnClick={handleGotoDetailCoupon({
                    idCoupon: coupon?.couponId,
                    transactionCode: coupon?.transactionCode,
                  })}
                />
              ))}
            </div>
          </div>
          <LoadingOverlay
            isLoading={isLoading.SAVE_SUGGESTED_COUPON}
            style={{ marginTop: "1rem" }}
          />
        </Dock>
      )}

      <Dock
        show={showUserLikedList}
        showBtnClose
        handleClose={handleCloseUserLikedList}
      >
        <LoadingOverlay
          isLoading={
            (isLoading.GET_USER_LIKED_LIST_OF_RATING_POST ||
              isLoading.GET_USER_LIKED_LIST_OF_COMMENT) &&
            likedListParams.skip === 0
          }
        />

        <div
          className="color-ucla_gold _fs-15px _fw-600 text-center text-1-line"
          style={{
            padding: "16px 40px 8px",
            lineHeight: "18px",
          }}
        >
          <span className="">Danh sách lượt thích</span>
        </div>

        <div
          className="people-liked-list__container"
          id="people-liked-list-popup"
        >
          <InfiniteScroll
            dataLength={userLikedData.list.length}
            next={handleFetchLikedList({
              id: likedListParams.id,
              type: likedListParams.type,
              take: likedListParams.take,
              skip: userLikedData.list.length,
            })}
            hasMore={userLikedData.hasMore}
            loader={renderLoaderOfUserLiked()}
            scrollableTarget="people-liked-list-popup"
          >
            <div className="people-liked-list">
              {!(
                (isLoading.GET_USER_LIKED_LIST_OF_RATING_POST ||
                  isLoading.GET_USER_LIKED_LIST_OF_COMMENT) &&
                likedListParams.skip === 0
              ) &&
                userLikedData.list.map((userLiked) => (
                  <div className="row-info" key={userLiked.id}>
                    <object
                      className="row-info__avatar"
                      data={userLiked.avatarUrl || IMAGES.AvatarPlaceholder}
                      type="image/png"
                    >
                      <img
                        className="row-info__avatar"
                        src={IMAGES.AvatarPlaceholder}
                        alt="ava"
                      />
                    </object>
                    <span className="row-info__name">{userLiked.name}</span>
                  </div>
                ))}
            </div>
          </InfiniteScroll>
        </div>
      </Dock>

      {/* 
      // TODO: refactor về dạng modal route
      */}
      <DetailRatingPost
        show={!!chosenRatingPost}
        handleClose={handleCloseDetailRatingPost}
        ratingPost={chosenRatingPost}
        handleUnlikeCmt={handleUnlikeCmt}
        handleLikeCmt={handleLikeCmt}
        handleOpenUserLikedList={handleOpenUserLikedList}
        handleLikeSubCmt={handleLikeSubCmt}
        handleUnLikeSubCmt={handleUnLikeSubCmt}
        handleSeeAllRating={handleSeeAllRating}
        handleSubmitReply={handleSubmitReply}
      />

      <CModal
        title="UTOP"
        show={showModalWarning}
        onClose={handleCloseModalWarning}
        scrollable={false}
        centered
      >
        <CModalHeader className="border-0">
          <span className="_fw-700">UTOP</span>
        </CModalHeader>
        <CModalBody className="py-0">
          Cảm ơn bạn đã quan tâm đến cửa hàng. Hiện tại cửa hàng chưa chính thức
          đi vào hoạt động. Bạn vui lòng quay lại sau nhé
        </CModalBody>
        <CModalFooter className="border-0">
          <CButton
            variant="ghost"
            onClick={() => {
              history.push("/");
            }}
          >
            Về trang chủ
          </CButton>
          {renderBackBtn()}
          {/* {location?.state?.prevPathname !== "/" && (
            <CButton variant="ghost" onClick={handleCloseModalWarning}>
              Quay lại
            </CButton>
          )} */}
        </CModalFooter>
      </CModal>
    </div>
  );
}

export default StoreView;
